import { signOut } from 'firebase/auth';
import { auth } from '../../firebase-config';
import {
  CLIENT_LOGIN_PATH,
  CLIENTS
} from '../../config/clientAccess';
import './ClientSelector.css';

const ClientSelector = ({ user }) => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.replace(CLIENT_LOGIN_PATH);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <main className="client-selector-page">
      <header className="client-selector-header">
        <div>
          <span className="client-selector-eyebrow">DataDos</span>
          <h1>Portal de clientes DataDos</h1>
          <p>Selecciona el cliente que quieres consultar</p>
        </div>

        <div className="client-selector-session">
          <span>{user?.email}</span>
          <button type="button" onClick={handleLogout}>Cerrar sesión</button>
        </div>
      </header>

      <section className="client-selector-grid" aria-label="Clientes disponibles">
        {Object.values(CLIENTS).map((client) => (
          <article className="client-selector-card" key={client.id}>
            <div className="client-selector-card-mark" aria-hidden="true">
              {client.name.charAt(0)}
            </div>
            <h2>{client.name}</h2>
            <p>{client.description}</p>
            <a href={client.path}>Acceder</a>
          </article>
        ))}
      </section>
    </main>
  );
};

export default ClientSelector;
